var map = {
	"./account/locales/en.json": "./src/modules/account/locales/en.json",
	"./auth/locales/en.json": "./src/modules/auth/locales/en.json",
	"./errors/locales/en.json": "./src/modules/errors/locales/en.json",
	"./errors/locales/ro.json": "./src/modules/errors/locales/ro.json",
	"./errors/locales/ru.json": "./src/modules/errors/locales/ru.json",
	"./roles/locales/en.json": "./src/modules/roles/locales/en.json",
	"./roles/locales/ro.json": "./src/modules/roles/locales/ro.json",
	"./roles/locales/ru.json": "./src/modules/roles/locales/ru.json",
	"./store/locales/en.json": "./src/modules/store/locales/en.json",
	"./users/locales/en.json": "./src/modules/users/locales/en.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";